import React, { useState, useEffect } from "react";
import {
  IonCard,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote,
  IonSearchbar,
  IonText,
} from "@ionic/react";
import { checkmarkDoneOutline, warningOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setLocationSearchText } from "../../../store/supervisorHome";
import { selectLocations } from "../../../store/supervisorHome/selectors/selectLocations";
import { selectLocationsSearchText } from "../../../store/supervisorHome/selectors/selectLocationsSearchText";
import api from "../../../utils/api";

const LocationCard: React.FC<{ location: any }> = ({ location }) => {
  const [imageSrc, setImageSrc] = useState('https://programacion.net/files/article/20161110041116_image-not-found.png');

  useEffect(() => {
    const fetchImage = async () => {
      if (location.picture) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${api.baseURL}archive/${location.picture}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setImageSrc(url);
          } else {
            console.error('Error fetching image:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchImage();
  }, [location.picture]);

  return (
    <IonCard
      style={{ width: "350px" }}
      routerLink={`/app/supervision/instalacion/${location.id}`}
      button
    >
      <img
        src={imageSrc}
        alt="Imagen documento"
        style={{
          height: "168px",
          width: "100%",
          objectFit: "cover",
          background: "white",
        }}
      />
      <IonItem lines="none">
        <IonLabel className="ion-text-wrap">
          <h2 style={{ fontWeight: 600, height: "47px" }}>
            {location.name} {location.organization?.name}
          </h2>
        </IonLabel>

        <IonNote slot="end" className="ion-border-start">
          <p style={{ fontSize: 19, fontWeight: 500, margin: 0 }}>
            {location.warnings.length ? (
              <IonText color={"warning"}>
                <IonIcon color={"warning"} icon={warningOutline}></IonIcon>
                <span className="ion-margin-start">{location.warnings.length}</span>
              </IonText>
            ) : (
              <IonText color={"success"}>
                <IonIcon color={"success"} icon={checkmarkDoneOutline}></IonIcon>
              </IonText>
            )}
          </p>
        </IonNote>
      </IonItem>
    </IonCard>
  );
};

export const LocationSelector: React.FC = () => {
  const locations = useSelector(selectLocations);
  const searchText = useSelector(selectLocationsSearchText);
  const dispatch = useDispatch();

  return (
    <>
      <h2 className="ion-margin-start">
        <IonText color="primary">Mis instalaciones ({locations?.length})</IonText>
      </h2>
      <IonSearchbar
        style={{ maxWidth: 360 }}
        placeholder="Buscar instalación"
        value={searchText}
        onIonChange={({ detail: { value = "" } }) => dispatch(setLocationSearchText(value))}
        className="ion-no-padding ion-padding-start ion-padding-bottom"
      ></IonSearchbar>
      <section>
        <section
          style={{
            padding: "10px 6px",
            display: "flex",
            overflow: "auto",
            scrollSnapType: "x mandatory",
          }}
        >
          {locations?.map((location, index) => (
            <article key={index} style={{ scrollSnapAlign: "center" }}>
              <LocationCard location={location} />
            </article>
          ))}
        </section>
      </section>
    </>
  );
};